import { render, staticRenderFns } from "./FirstReceptionCheck.vue?vue&type=template&id=15e139df&"
import script from "./FirstReceptionCheck.ts?vue&type=script&lang=ts&"
export * from "./FirstReceptionCheck.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports